const MAIN = "/";
const BOOK = "/book";
const STUDIED_WORDS = "/dictionary/studied-words";
const DIFFICULT_WORDS = "/dictionary/difficult-words";
const DELETED_WORDS = "/dictionary/deleted-words";
const SAVANNAH = "/game/savannah";
const AUDIO_CALL = "/game/audio-call";
const SPRINT = "/game/sprint";
const OWN_GAME = "/game/own-game";
const STATISTICS = "/statistics";
const SIGN_IN = "/signIn";
const SIGN_UP = "/signUp";

export {
  MAIN,
  BOOK,
  STUDIED_WORDS,
  DIFFICULT_WORDS,
  DELETED_WORDS,
  SAVANNAH,
  AUDIO_CALL,
  SPRINT,
  OWN_GAME,
  STATISTICS,
  SIGN_IN,
  SIGN_UP,
};
